import React from 'react';

import { graphql } from 'gatsby';

import { styled } from '@mui/material';

import { extractTextMarking } from '@mewa/ui';

import { ComponentProps, PossibleContentSections } from '../fragment-and-types';
import { ContentLivePreviewConfig } from '../live-preview/types';

export const Heading2CenterFragment = graphql`
  fragment Heading2CenterFragment on STRAPI__COMPONENT_SHARED_HEADING_2_CENTER {
    title
    subtitle
    strapi_component
  }
`;

export const componentName = 'shared.heading-2-center';

export type Heading2CenterData = {
  title: string;
  subtitle: string;
  strapi_component: typeof componentName;
};

export type Heading2CenterPreviewData = Heading2CenterData;

export const isHeading2Center = (
  component: PossibleContentSections,
): component is Heading2CenterData => {
  return component.strapi_component === componentName;
};

export const StrapiHeading2Center = ({
  title,
  subtitle,
}: ComponentProps<Heading2CenterData>) => {
  const markedHeadline = extractTextMarking(title);

  return (
    <Container>
      <Headline>
        {markedHeadline.beforeMarking}
        <strong>{markedHeadline.marking}</strong>
        {markedHeadline.afterMarking}
      </Headline>
      <Subline>{subtitle}</Subline>
    </Container>
  );
};

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}));

const Headline = styled('h2')(({ theme }) => ({
  ...theme.typography.h2,
  fontWeight: theme.typography.fontWeightMedium,
  textAlign: 'center',
  marginBottom: 0,
  marginTop: 0,
  width: '80%',
}));

const Subline = styled('h2')(({ theme }) => ({
  ...theme.typography.h4,
  fontWeight: theme.typography.fontWeightMedium,
  textAlign: 'center',
  marginTop: '36px',
  marginBottom: 0,
}));

export const config = {
  isComponent: isHeading2Center,
  Component: StrapiHeading2Center,
  componentName,
};

export const previewConfig: ContentLivePreviewConfig = {
  componentName,
  populationParams: {},
  mapProperties: (heading2Center): Heading2CenterData | null =>
    heading2Center.strapi_component === componentName ? heading2Center : null,
};
